import { EXPLORE_CATALOG_CACHE_KEY } from "../actions/v2/explore";
import { invalidateCachedGet } from "./apiResponseCache";

/** Fired when Explore module entitlements change (include / revoke). */
export const ENTITLEMENTS_EVENT = "iship-module-entitlements-changed";

export const notifyEntitlementsChanged = () => {
  try {
    invalidateCachedGet(EXPLORE_CATALOG_CACHE_KEY);
    window.dispatchEvent(new Event(ENTITLEMENTS_EVENT));
  } catch {
    /* ignore */
  }
};
